import React from 'react';
import { useLocation } from 'react-router-dom';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import ModuleLayout from '../../../layouts/ModuleLayout';
import InventoryHub from '../../../components/Admin/Inventory/InventoryHub';

/**
 * Inventory Hub Page
 *
 * Main inventory page that shows all available inventory sections in a sidebar.
 * Users can navigate between different inventory management features.
 */
export default function InventoryHubPage() {
  const location = useLocation();

  // Detect if accessed from Inventory module directly
  const isInventoryModule = location.pathname.startsWith('/inventory');
  const Layout = isInventoryModule ? ModuleLayout : AdminLayout;

  return (
    <Layout>
      <InventoryHub />
    </Layout>
  );
}
